import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { environment } from '../../environments/environments'

@Injectable({
  providedIn: 'root'
})
export class RolesService {

  constructor(private http: HttpClient ) { }

  retriveOpreators(){
    return this.http.get(`${environment.baseUrl}/role/all`)
  }

  retrivePermison(){
    return this.http.get(`${environment.baseUrl}/permission/`)
  }

  addRole(data:any){
    return this.http.post(`${environment.baseUrl}/role/`,data)
  }
  addpermiosnForRole(data:any){
    return this.http.put(`${environment.baseUrl}/role/addPermission`,data)
  }

  retriveRoles(){
    return this.http.get(`${environment.baseUrl}/role/all`)
  }

  roleDetails(id:any){
    return this.http.get(`${environment.baseUrl}/role/?role_id=${id}`)
  }

  editRole(data:any){
    return this.http.put(`${environment.baseUrl}/role/`,data)
  }

  changePw(data:any){
    return this.http.post(`${environment.baseUrl}/auth/forgot`,data)
  }
}
